<template>
  <div class="notification-message mb-2">
    <b-alert show :variant="variant" :style="customStyle">
      <h1>
        <b-icon-exclamation-circle class="mr-2"></b-icon-exclamation-circle>
        <slot>提交失敗</slot>
      </h1>
      <ul v-if="messages">
        <li v-for="message in filteredMessages" :key="message">{{ message }}</li>
      </ul>
    </b-alert>
  </div>
</template>

<script>
import { BIconExclamationCircle, BAlert } from 'bootstrap-vue';

export default {
  components: {
    BIconExclamationCircle,
    BAlert,
  },
  props: {
    error: {
      type: [String],
    },
    messages: {
      type: [Array, Object],
    },
    variant: {
      type: [String],
      default: 'danger',
    },
    customStyle: {
      type: [String],
      default: '',
    },
  },
  computed: {
    filteredMessages() {
      const messageList = [];

      Object.values(this.messages).forEach(([message]) => {
        if (message) {
          messageList.push(message);
        }
      });
      return messageList;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-message {
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
  font-size: 16px;

  .alert {
    border-color: transparent;
    margin-bottom: 0;
    padding: 15px 25px;

    &-danger {
      background: rgb(255, 223, 225);
      color: rgb(207, 53, 56);
    }
  }

  h1 {
    font-size: inherit;
    margin: 0;

    span {
      font-weight: 400
    }
  }

  ul {
    line-height: 150%;
    list-style-type: disc;
    margin-top: 5px;
    margin-left: 0px;
    margin-bottom: 0;
    padding-left: 20px;

    li {
      color: rgb(211, 66, 69);
    }
  }
}
</style>
